// extracted by mini-css-extract-plugin
module.exports = {"vip_box":"vip_box-2vt09NS4","fl":"fl-bKFRNnPf","fr":"fr-3C9PTUrE"};